import { Box } from "@mui/material";
import { useActiveColorId, useTemplate } from "containers/templateDetail/store";
import * as React from "react";
import "swiper/css";
import "swiper/css/thumbs";
import "swiper/css/virtual";
import MainImage from "./mainImage";
import ThumbsImage from "./thumbsImage";

const previewListWidth = 100;

export default function ImagePreview(): React.ReactElement {
  const [thumbsSwiper, setThumbsSwiper] = React.useState(null);
  const { images: templateImages } = useTemplate();
  const activeColorId = useActiveColorId();

  const images = React.useMemo(() => {
    if (activeColorId === null) {
      return templateImages;
    }
    return templateImages.filter((item) => item.color_id === activeColorId);
  }, [activeColorId, templateImages]);

  // const previewListWidth = React.useMemo(() => {
  //   return 100;
  // }, []);

  return (
    <Box
      sx={{
        position: "sticky",
        top: 80,
        display: "flex",
        flexDirection: {
          xs: "column-reverse",
          md: "row",
        },
      }}
    >
      <Box
        sx={{
          width: {
            xs: "100%",
            md: previewListWidth,
          },
          display: "flex",
          flexDirection: {
            xs: "row",
            md: "column",
          },
          mt: {
            xs: 1,
            md: 0,
          },
        }}
      >
        <ThumbsImage
          images={images}
          activeImageId={0}
          width={previewListWidth}
          swiper={thumbsSwiper}
          setSwiper={setThumbsSwiper}
        />
      </Box>
      <Box
        sx={{
          flex: 1,
          position: "relative",
          fontSize: 0,
          width: { xs: "auto", md: 0 },
          ml: {
            xs: 0,
            md: 1,
          },
        }}
      >
        <MainImage images={images} thumbsSwiper={thumbsSwiper} />
      </Box>
    </Box>
  );
}
